<div class="card" *blockUI="'section-block'">
    <div class="row d-flex align-items-center mt-1 mb-1">
        <div class="col-md-6 col-12 d-flex justify-content-between align-items-center">
            <a href="#/admin/transaction-description-create">
                <button class="btn btn-primary ml-1" rippleEffect>
                    <i data-feather="plus" class="d-sm-none d-inline-block mr-0 mr-sm-1"></i>
                    <span class="d-none d-sm-inline-block">Açıklama Ekle</span>
                </button>
            </a>
        </div>

        <div class="col-md-6 col-12 d-flex justify-content-end">
            <label class="d-flex align-items-end mb-0">
                <select class="form-control mx-25" [(ngModel)]="basicSelectedOption" (ngModelChange)="onOptionChange()">
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="50">50</option>
                </select>
            </label>
            <div class="d-flex align-items-center justify-content-end pr-1 pb-1 pl-1 pl-md-0 pb-md-0">
                <label class="d-flex align-items-center mb-0">
                    <input type="search" placeholder="Bul" class="form-control ml-25" (keyup)="filterUpdate($event)"
                        (search)="filterUpdate($event)" />
                </label>
            </div>
        </div>
    </div>

    <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" style="cursor: pointer;" [messages]="{ 
      emptyMessage: 'Veri Yok',
      totalMessage: 'Toplam', 
      selectedMessage: 'Seçili'
    }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
        [scrollbarH]="true">

        <ngx-datatable-column name="Açıklama Başlığı" prop="title" class="ellipsis-column" [width]="400">
        </ngx-datatable-column>
        <ngx-datatable-column name="Oluşturma Tarihi" [width]="60">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{row.cratedAt | date: 'dd.MM.yyyy HH:mm'}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [width]="40" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
                <div ngbDropdown container="body">
                    <button ngbDropdownToggle type="button" class="btn icon-btn btn-sm hide-arrow" rippleEffect>
                        <span [data-feather]="'more-vertical'" [class]="'cursor-pointer'"></span>
                    </button>
                    <div ngbDropdownMenu>
                        <a href="#/admin/transaction-description/{{row.id}}" ngbDropdownItem
                            class="d-flex align-items-center"><i data-feather="file-text"
                                class="mr-50"></i>Görüntüle</a>
                        <a appDelete controller="TransactionManagementDescription" [id]="row.id"
                            (callback)="getAllTransactionDescription(this.pageBasic - 1, this.selectedSize)"
                            ngbDropdownItem><span [data-feather]="'trash'" [size]="16" [class]="'mr-50'"></span> Sil</a>
                    </div>
                </div>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>


                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event)">
                        <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'" [size]="18"
                                [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'" [size]="18"
                                [class]="'font-weight-bolder'"></span></ng-template>
                    </ngb-pagination>
                </div>

            </ng-template>

        </ngx-datatable-footer>
    </ngx-datatable>
</div>